/**
 * calc days of separation between 2 dates as javascript date obj or iso compatible
 * returns int
 */
export const daysOfSeparation = (dateStart, dateEnd) => {
  dateStart = new Date(dateStart);
  dateEnd = new Date(dateEnd);
  return Math.floor((dateEnd - dateStart) / (1000*60*60*24))
}

/**
 * Calc months of separation expects input date objects, returns number 
 */
export const monthsOfSeparation = (dateStart, dateEnd) => {
  let months = (dateEnd.getFullYear() - dateStart.getFullYear()) * 12;
  months -= dateStart.getMonth();
  months += dateEnd.getMonth();
  return months <= 0 ? 0 : months;
}

export const yearsOfSeparation = (dateStart, dateEnd) => {
  let years = (dateEnd.getFullYear() - dateStart.getFullYear());
  return years <= 0 ? 0 : years;
}

export const minutesOfSeparation = (dateStart, dateEnd) => {
  const diffMs = (dateEnd - dateStart); // milliseconds between now & Christmas
  //const diffDays = Math.floor(diffMs / (1000*60*60*24)); // days
  //const diffHrs = Math.floor((diffMs % (1000*60*60*24)) / 3600000); // hours
  //const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
  return Math.floor(diffMs / (1000*60));
}